import React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { getDraftTravelInsuranceList } from '../../redux/modules/insurances';
import { tableDateFormat } from '../../helpers/dates';
import { continueFromDraft } from '../../redux/modules/travelContract';
import { TRAVEL_CONTRACT_SIGN_PATH } from '../../constants/routes';
import formatCurrency from '../../helpers/formatCurrency';
import DraftInsurancesTable from './DraftInsurancesTable';

const DraftTravelInsurancesTable = () => {
  const { t } = useTranslation();
  const { tblData, isLoading } = useSelector(
    (store) => store.insurances.draftTravelInsuranceList, shallowEqual,
  );

  const columns = [
    {
      title: 'insuranceList.contractNumber',
      property: 'draftId',
      sortable: false,
      format: (v) => v.split('_')[3],
    },
    {
      title: 'insuranceList.from',
      property: 'contractStart',
      sortable: false,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.to',
      property: 'contractEnd',
      sortable: false,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.zone',
      property: 'region',
      sortable: false,
      format: (v) => v && t(`travel.region.${v}.title`),
    },
    {
      title: 'insuranceList.program',
      property: 'plan',
      sortable: false,
      format: (v) => v && v.type && t(`travel.types.${v.type}.title`),
    },
    {
      title: 'insuranceList.limit',
      property: 'limit',
      sortable: false,
      format: (v) => v && v.currency
          && `${t(`currency.${v.currency.toUpperCase()}`)} ${formatCurrency(v.value)}`,
    },
  ];

  return (
    <DraftInsurancesTable
      title="insuranceList.draftTravelInsurances"
      uri={TRAVEL_CONTRACT_SIGN_PATH}
      columns={columns}
      tblData={tblData}
      isLoading={isLoading}
      getDraftInsuranceList={getDraftTravelInsuranceList}
      continueFromDraft={continueFromDraft}
    />
  );
};

export default DraftTravelInsurancesTable;
